/* eslint-disable no-unused-vars */
import moment from 'moment';
import { HomeSelector } from 'selectors';

const { getGreetingsText, getImagesName, getMotivationalText } = HomeSelector;

const getGreetingImagesAndText = ({ greetings }) => {
  const today = moment(new Date(), 'DD/MM/YYYY');
  const { date, greetingTextIndex, imageIndex, motivationTextIndex } = greetings;

  const formatDate = date ? moment(date, 'DD/MM/YYYY') : null;

  const isSameDay = today.isSame(formatDate, 'day');
  if (!isSameDay) {
    let randomImage = Math.floor(Math.random() * getImagesName().length);
    let randomGreeting = Math.floor(Math.random() * getGreetingsText().length);
    let randomMotivation = Math.floor(Math.random() * getMotivationalText().length);

    while (imageIndex === randomImage)
      randomImage = Math.floor(Math.random() * getImagesName().length);
    while (greetingTextIndex === randomGreeting)
      randomGreeting = Math.floor(Math.random() * getGreetingsText().length);
    while (motivationTextIndex === randomMotivation)
      randomMotivation = Math.floor(Math.random() * getMotivationalText().length);

    return {
      date: today.format('DD/MM/YYYY').toString(),
      imageIndex: randomImage,
      greetingTextIndex: randomGreeting,
      motivationalTextIndex: randomMotivation
    };
  } else {
    return null;
  }
};

export { getGreetingImagesAndText };
